import { Controller } from "@hotwired/stimulus"
import Honeybadger from "@honeybadger-io/js"
import { planningMutation } from "../planning_mutation"

// Drop target on a timeline trade-demand bar (Planning::Timeline::TradeDemandBarComponent). An
// employee dropped here fills the demand's open slots across the whole run (POST to fulfill_range).
// Only employee drags are handled; trade / other drags carry no employee payload, so the drop falls
// through to the section's planning-board-drop handler — dropping a Trade still creates a new demand.
export default class extends Controller {
  drop(event) {
    try {
      const payload = event.dataTransfer.getData("application/json")
      if (!payload) return

      const data = JSON.parse(payload)
      if (data.resourceType !== "Employee" || !data.resourceId) return

      // Only stop propagation for employee drops; everything else falls through to the section.
      event.preventDefault()
      event.stopPropagation()
      this.element.classList.remove("ring-2", "ring-emerald-400")

      const bar = this.element
      planningMutation({
        url: bar.dataset.fulfillRangeUrl,
        method: "POST",
        body: {
          employee_id: data.resourceId,
          trade_id: bar.dataset.tradeId,
          plannable_type: bar.dataset.plannableType,
          plannable_id: Number(bar.dataset.plannableId),
          date_from: bar.dataset.spanFrom,
          date_to: bar.dataset.spanTo,
        },
        component: "planning-trade-fill-range",
      })
    } catch (error) {
      Honeybadger.notify(error, {
        context: { component: "planning-trade-fill-range", action: "drop" },
      })
    }
  }

  dragover(event) {
    // preventDefault allows the drop to fire; the drop handler filters to employee drags.
    event.preventDefault()
    event.dataTransfer.dropEffect = "copy"
  }

  dragenter(event) {
    event.preventDefault()
    this.element.classList.add("ring-2", "ring-emerald-400")
  }

  dragleave(event) {
    if (event.relatedTarget && this.element.contains(event.relatedTarget)) return
    this.element.classList.remove("ring-2", "ring-emerald-400")
  }
}
